module.exports = __webpack_public_path__ + "img/cover4.cc2cb70e.jpg";